<template>
  <div class="page-with-top-bar">
   <div class="flex mb-4 is-justify-content-flex-end gap-1">
      <v-button type="is-primary" @click="groupModalActive = true" icon="add">
          {{ $t('add_group') }}
      </v-button>
    </div>
    <section>
      <div :class="!activityId ? 'card p-2 mt-4' : ''">
      <span class="text-xl text-blue font-bold">{{ $t('groups') }}</span>
      <br />
      {{ $t('select_groups') }}

      <b-table
        :data="kpiGroups"
        :loading="loading"

        paginated
        :per-page="25"
        :pagination-simple="true"
        :total="kpiGroups.length"
        detailed
        detail-key="id"
        @details-open="loadGroupAssignments"
        icon-pack="fas"
        class="text-xs border-blue-lighter"
        bordered
        narrowed
        striped

        checkable
        checkbox-position="left"
        :checkbox-type="'is-success'"
        :checked-rows.sync="selectedGroups"
        >

        <template slot="empty">
            <div v-if="! loading" class="m-4 text-lg text-dark-grey">
              <span>{{ $t('no_results') }}</span>
            </div>
        </template>

        <template>
          <!-- name, subactividades, mediciones relacionadas, unidades de medida relacionadas -->
          <b-table-column field="name" :label="$t('name')" width="40%" class="text-left" v-slot="group">
            <template >
              <div class="flex items-center">
                <span>{{ group.row.name }}</span>
              </div>
            </template>
          </b-table-column>
          <b-table-column field="measurements" :label="$t('assignments')" width="20%" class="text-left" v-slot="group">
            <template >
              <div class="flex items-center">
                <span>{{ group.row.assignment_objects_count }}</span>
              </div>
            </template>
          </b-table-column>

          <!-- por el momento quitado. es pesado cargar todas las unidades
          <b-table-column field="units" label="Unidades" width="20%" class="text-left" v-slot="group">
            <template >
              <div class="flex items-center">
                <span>{{ group.row.units }}
                 </span>
              </div>
            </template>
          </b-table-column> -->

          <!-- add activity-->
          <b-table-column field="add" :label="$t('actions')" width="10%" class="text-left" v-slot="group">
            <template>
              <div class="flex items-center">
                <b-tooltip :label="$t('add')" position="is-left">
                  <div @click.stop="handleAddClick(group.row)" class="cursor-pointer flex text-green ml-2">
                    <b-icon pack="fas" icon="plus-circle" />
                  </div>
                </b-tooltip>
                <i @click="deleteKpiGroup(group.row.id)"
                  class="fas fa-trash text-red cursor-pointer ml-4"
                ></i>
              </div>
            </template>
          </b-table-column>

        </template>


       <template slot="detail" slot-scope="group">
        <b-collapse
          class="card"
          animation="slide"
          aria-id="contentIdForA11y3"
          @open="loadGroupAssignments(group.row)"
          >
          <template #trigger="props">
            <div
              class="card-header"
              role="button"
              aria-controls="contentIdForA11y3"
              :aria-expanded="props.open">
              <div class="card-header-title">
                <h4>
                  <b>{{ $t('measurements') }}</b>
                </h4>
              </div>
              <a class="card-header-icon">
                <b-icon icon-pack="fas"
                  :icon="props.open ? 'caret-down' : 'caret-up'">
                </b-icon>
              </a>
            </div>
          </template>

          <div class="card-content p-0">
            <div class="content">
              <template>
              <b-table
                    :data="group.row.assignment_objects || []"
                    :loading="group.row.loadingAssignments"
                    :total="(group.row.assignment_objects || []).length"
                    icon-pack="fas"
                    class="text-xs border-blue-lighter"
                    bordered
                    narrowed
                    striped
                  >
                  <template slot="empty">
                    <div v-if="!loading" class="m-4 text-lg text-dark-grey">
                      <span>{{ $t('empty_activities_table_msg') }}</span>
                    </div>
                  </template>
                  <template>
                    <b-table-column field="name" :label="$t('name')" width="40%" class="text-left" v-slot="assignment">
                      <template>
                        <div class="flex items-center">
                          <span>{{ assignment.row.name }}</span>
                        </div>
                      </template>
                    </b-table-column>
                    <b-table-column field="code" :label="$t('code')" width="20%" class="text-left" v-slot="assignment">
                      <template>
                        <div class="flex items-center">
                          <span>{{ assignment.row.code }}</span>
                        </div>
                      </template>
                    </b-table-column>
                    <b-table-column field="unit_name" :label="$t('unit')" width="20%" class="text-left" v-slot="assignment">
                      <template>
                        <div class="flex items-center">
                          <span>{{ assignment.row.unit_name }}</span>
                        </div>
                      </template>
                    </b-table-column>
                    <b-table-column :label="$t('actions')" width="10%" class="text-center" v-slot="assignment">
                      <b-tooltip :label="$t('remove')" position="is-left" type="is-danger">
                          <div @click.stop="deleteKpiAssignment(assignment.row)" class="cursor-pointer flex text-red ml-2">
                              <b-icon pack="fas" icon="trash-alt" />
                          </div>
                      </b-tooltip>
                    </b-table-column>
                  </template>
                </b-table>
              </template>
            </div>
          </div>
        </b-collapse>
      </template>
      </b-table>

      <br>
      <div class="flex items-end">
        <svg width="60" height="60" viewBox="0 0 60 65" xmlns="http://www.w3.org/2000/svg">
          <!-- L-shaped arrow as single line -->
          <path d="M10 10 L10 50 L60 50 L50 40 M60 50 L50 60" 
                fill="none" 
                stroke="#4a5568" 
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>

        {{ $t('show_kpi_of_selected_groups') }}
        <v-button icon="table" @click="goToKpiPreTable()" class="ml-4 mr-4" :disabled="selectedGroups.length == 0">
          {{ $t('see_kpi') }}
        </v-button>
      </div>

    </div>
    </section>
      <link-activities-modal
      :active="activitiesModalActive"
      :activities="activitiesArray"
      :assignments="assignmentsForActivity"
      :assigned-activities="selectedActivities"
      :loading-activity="loadingActivity"
      :mode="activityId ? 'assignments' : 'activities'"
      :activity-id="activityId"
      @save="addKpiActivity"
      @close="activitiesModalActive = false"
    />


    <!-- Modal: Crear Grupo Principal -->
    <b-modal :active.sync="groupModalActive" :width="600" scroll="keep" :can-cancel="canCancel"
        @close="closeGroupModal">
        <div class="border border-blue-light rounded shadow bg-white p-4">
            <div class="modal-card-body_ relative w-full">
                <header class="font-thin uppercase text-blue-light modal-card-head_ mb-4">
                    {{ $t('add_group') }}
                </header>
                <section class="px-2 mb-3">
                    <b-field :label="$t('name')">
                        <b-input v-model="group.name" :placeholder="$t('name')" required />
                    </b-field>
                    <b-field :label="$t('description')">
                        <b-input v-model="group.description" :placeholder="$t('description')" />
                    </b-field>
                </section>
            </div>
            <footer class="modal-card-foot_ border-grey-light border-t border-dashed mb-2">
                <div class="w-full inline-flex justify-end mt-4">
                    <b-button type="is-primary" @click="saveGroup" :disabled="!group.name">
                        {{ $t('add_generic') }}
                    </b-button>
                    <b-button @click="groupModalActive = false" class="ml-2">{{ $t('cancel') }}</b-button>
                </div>
            </footer>
        </div>
    </b-modal>
    
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from 'axios'
  import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
  import LinkActivitiesModal from '../kpis/kpis-daily/link-activities-modal.vue';

  export default {
    components: {
      ProjectAdminQuickButtons,
      LinkActivitiesModal
    },
    
    props: {
      activityId: {
        type: [Number, String],
        default: null
      },
      projectId: {
            type: Number,
            required: true
        },
    },

    computed: {
      ...mapGetters({
        navData: "app/navData",
      }),
    },

    data: () => ({
      kpiGroups: [],
      activities: [],
      activitiesFiltered: [],
      parents: [],
      filterParentId: null,
      groupName: "",
      selectedActivities: [],
      selectedGroups: [], // grupos elegidos para ver sus kpi

      activitySelected: null,
      loading: false,
      isAddGroup: false,
      isAddActivity: false,

      // activities table
      currentPage: 1,
      isPaginated: true,
      isPaginationSimple: true,
      defaultSortDirection: 'asc',
      loadingActivity: false,

      groupIdSelected: null,

      activitiesModalActive: false,
      activitiesArray: [],
      selectedGroupForActivities: null,
      groupModalActive: false,
      assignmentsForActivity: [], // Assignments cuando existe activityId
      group: {
        name: '',
        description: ''
      },
      canCancel: ['escape', 'x', 'outside'],
    }),


    created() {
      let projectName = this.navData.project_name
        ? this.navData.project_name.toUpperCase()
        : "";

      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];
      this.getKpiGroups()
      this.getProjectKpiActivities()
    },


    methods: {

      addButton(row) {
        // buscar si ya esta agregando una actividad
        const activity = this.kpiGroups.find(group => group.isAdd)
        if (activity) {
          activity.isAdd = false
        }

        if (this.isAddActivity) {
          this.isAddActivity = false
          this.groupIdSelected = null
          row.isAdd = false
        } else {
          this.isAddActivity = true
          this.groupIdSelected = row.id
          row.isAdd = true
        }

      },

      filterActivities(selected) {
        if (!selected) {
          this.activitiesFiltered = this.activities
          return
        }
        this.activitiesFiltered = this.activities.filter(activity => {
          return activity.parent_id 
            ? activity.parent_id == selected.id 
            : activity.id == selected.id;
        });
      },

      async getKpiGroups() {
        this.loading = true;
        let url = `/api/v2/project/${this.projectId}/kpi-groups`;
        const params = {};
        if (this.activityId) {
            params.activity_id = this.activityId;
        }
        const { data } = await axios.get(url, { params });
        if (data && data.success) {
            this.kpiGroups = data.data;
            this.loading = false;
        } else {
            this.$notify.error('error_loading_activity_data');
        }
      },

      // TODO deberia cargarse solo al pulsar en añadir grupo
      async getProjectKpiActivities() {
        this.loadingActivity = true;
        const params = {type: 0};
        if (this.activityId) {
          params.activity_id = this.activityId;
        }
        const { data } = await axios.get('/api/v2/project/' + this.projectId + '/kpi-activities', { params });
        if (data && data.success) {
          const activitiesWithResources = data.data || [];
          const allParents = data.parents || [];
          
          // Cuando existe activityId, solo hay una actividad con sus assignments en resources
          if (this.activityId && activitiesWithResources.length > 0) {
            // Guardar los assignments de la actividad para usarlos en el modal
            this.assignmentsForActivity = activitiesWithResources[0].resources || [];
            this.activities = activitiesWithResources;
          } else {
            // Incluye los padres que no están en activitiesWithResources
            const allActivities = [
              ...activitiesWithResources,
              ...allParents.filter(parent => !activitiesWithResources.some(a => a.id === parent.id))
            ];
            this.activities = allActivities;
            this.assignmentsForActivity = [];
          }
          
          this.activitiesFiltered = this.activities;
          this.parents = allParents;
          this.loadingActivity = false;
        } else {
          this.$notify.error('error_loading_activity_data');
        }
      },

      async addKpiActivity(payload) {
        // Cuando existe activityId, el payload viene como array de IDs de assignments
        // Necesitamos convertirlo al formato esperado: [{ activity_id, assignments: [...] }]
        let dataToSend;
        
        if (this.activityId) {
          // Extraer los IDs de assignments del payload (vienen como 'res-{id}')
          const assignmentIds = payload
            .filter(id => typeof id === 'string' && id.startsWith('res-'))
            .map(id => parseInt(id.replace('res-', ''), 10));
          
          // Formato esperado: una sola activity con sus assignments
          dataToSend = {
            activities: [{
              activity_id: parseInt(this.activityId, 10),
              assignments: assignmentIds
            }]
          };
        } else {
          // Modo normal: el payload ya viene en el formato correcto
          dataToSend = { activities: payload };
        }
        
        const { data } = await axios.post(
          `/api/v2/kpi-group/${this.groupIdSelected}/activity-and-assignments`,
          dataToSend
        );

        if (data && data.success) {
          this.$notify.success('updated');
          await this.getKpiGroups();
          const group = this.kpiGroups.find(g => g.id === this.groupIdSelected);
          if (group) {

            this.$set(group, 'assignment_objects', undefined);
            await this.loadGroupAssignments(group);
          }
          this.groupName = "";
          this.selectedActivities = [];
          this.isAddGroup = false;
          this.isAddActivity = false;
          this.groupIdSelected = null;
          this.activitiesModalActive = false;
        } else {
          this.$notify.error('error_saving');
        }
      },


      deleteKpiGroup(groupId) {
        this.$buefy.dialog.confirm({
          title: 'Eliminar Grupo',
          message: '¿Estás seguro de que deseas eliminar este grupo?',
          confirmText: 'Eliminar',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.deleteKpiGroupConfirmed(groupId)
          }
        })
      },


      deleteKpiActivity(activityId) {
        this.$buefy.dialog.confirm({
          title: 'Eliminar Actividad',
          message: '¿Estás seguro de que deseas eliminar esta actividad?',
          confirmText: 'Eliminar',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.deleteKpiActivityConfirmed(activityId)
          }
        })
      },


      async deleteKpiActivityConfirmed(activityId) {
        const { data } = await axios.delete('/api/v2/kpi-acitivity/'+activityId)
        if (data && data.success) {
          this.$notify.success('Actividad eliminada')
          this.getKpiGroups()
        } else {
          this.$notify.error('Error eliminando actividad')
        }
      },


      async deleteKpiGroupConfirmed(groupId) {
        const { data } = await axios.delete('/api/v2/project/'+this.projectId+'/kpi-group/'+groupId)
        if (data && data.success) {
          this.$notify.success('Grupo eliminado')
          this.getKpiGroups()
        } else {
          this.$notify.error('Error eliminando grupo')
        }
      },

      goToKpiPreTable() {
        if (this.selectedGroups.length == 0) {
          this.$notify.error('select_groups')
          return
        }
        const groupIds = this.selectedGroups.map(group => group.id)
        // Emitir el evento hacia el padre
        this.$emit('ActivityHomeShowFullWidth', {
          groupIds,
          projectId: this.projectId,
          activityId: this.activityId
        })
      },

      openActivitiesModal(group) {
        this.selectedGroupForActivities = group;
        this.groupIdSelected = group.id;
        
        // Cuando existe activityId, mostramos assignments en lugar de activities
        if (this.activityId) {
          // Pasar las activities con sus resources al modal como respaldo
          // El modal extraerá los resources si assignmentsForActivity está vacío
          this.activitiesArray = this.activities || [];
          // Los assignments ya están en this.assignmentsForActivity
          // Preparar los assignments seleccionados del grupo
          this.selectedActivities = (group.assignment_objects || [])
            .map(r => `res-${r.id}`);
        } else {
          // Modo normal: mostrar activities
          this.activitiesArray = this.activities || [];
          this.parents = this.activitiesArray
            .map(a => ({ name: a.parent_name, id: a.parent_id }))
            .filter((v, i, a) => v.id && a.findIndex(t => t.id === v.id) === i);
          this.selectedActivities = (group.assignment_objects || [])
            .map(r => `res-${r.id}`);
        }
        this.activitiesModalActive = true;
      },

      async deleteKpiAssignment(assignment) {
        try {
          this.$dialog.confirm({
            title: this.$t('delete'),
            message: this.$t('delete_confirm_text', [assignment.name]),
            confirmText: this.$t('delete'),
            type: 'is-danger',
            hasIcon: true,
            onConfirm: async () => {
              const url = `/api/v2/project/${this.projectId}/kpi-assignment/${assignment.kpi_assignment_id}`;
              const { data } = await axios.delete(url);
              if (data && data.success) {
                this.$buefy.toast.open({
                  message: this.$t('assignment_remove_success'),
                  type: 'is-success'
                });
                await this.getKpiGroups();
                const group = this.kpiGroups.find(g => g.id === assignment.kpi_group_id);
                if (group) {
                  this.$set(group, 'assignment_objects', undefined);
                  await this.loadGroupAssignments(group);
                }
              } else {
                this.$buefy.toast.open({
                  message: this.$t('assignment_remove_error'),
                  type: 'is-danger'
                });
              }
            }
          });
        } catch (error) {
          this.$buefy.toast.open({
            message: this.$t('assignment_remove_error'),
            type: 'is-danger'
          });
        }
      },

      async saveGroup() {
        if (!this.group.name) {
          this.$notify.error(this.$t('empty_field_required', [this.$t('name')]));
          return;
        }
        try {
          const payload = {
            name: this.group.name,
            description: this.group.description
          };
          if (this.activityId) {
            payload.activity_id = this.activityId; 
          }
          const { data } = await axios.post(`/api/v2/project/${this.projectId}/kpi-group`, payload);
          if (data && data.success) {
            this.$notify.success(this.$t('success_creating_group'));
            this.groupModalActive = false;
            this.group.name = '';
            this.group.description = '';
            this.getKpiGroups();
          } else {
            this.$notify.error(this.$t('error_creating_group'));
          }
        } catch (e) {
          this.$notify.error(this.$t('error_creating_group'));
        }
      },

      closeGroupModal() {
          this.groupModalActive = false;
          this.group.name = '';
          this.group.description = '';
      },

      async loadGroupAssignments(group) {
        if (group.assignment_objects) return;

        this.$set(group, 'loadingAssignments', true);
        try {
          const url = `/api/v2/project/${this.projectId}/kpi-group/${group.id}`;
          const { data } = await axios.get(url);
          if (data && data.success && data.data) {
            this.$set(group, 'assignment_objects', data.data || []);
          }
        } catch (e) {
          this.$notify.error('Error cargando datos del grupo');
        }
        this.$set(group, 'loadingAssignments', false);
      },

      async handleAddClick(group) {
        if (!group.assignment_objects) {
          await this.loadGroupAssignments(group);
        }
        this.openActivitiesModal(group);
      },

    }
  };
</script>
